<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import confetti from 'canvas-confetti'

const confettiContainer = ref(null)

const triggerConfetti = () => {
  confetti({
    particleCount: 200,
    spread: 160,
    origin: { y: 0.6 },
  })
}

const triggerBadNews = () => {
  var scalar = 2;
  var sad = confetti.shapeFromText({ text: '🙁', scalar });
  var moneyLost = confetti.shapeFromText({ text: '💸', scalar });

  var defaults = {
    spread: 360,
    ticks: 120,
    gravity: 0.5,
    decay: 0.96,
    startVelocity: 25,
    shapes: [sad, moneyLost],
    scalar
  };

  function shoot() {
    confetti({
      ...defaults,
      particleCount: 30
    });

    confetti({
      ...defaults,
      particleCount: 5,
      flat: true
    });

  }

  setTimeout(shoot, 0);
  setTimeout(shoot, 100);
  setTimeout(shoot, 200);
}

onMounted(() => {
  window.triggerConfetti = triggerConfetti
  window.triggerBadNews = triggerBadNews
})

onBeforeUnmount(() => {
  window.triggerConfetti = null
})
</script>
<template>
  <div ref="confettiContainer" class="fixed top-0 left-0 w-full h-full pointer-events-none"></div>
</template>
<style scoped></style>
